import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { URL } from '../../../routers/constants';
import { formatPrice, showErrorToasts } from '../../../services/helpers/Helper';
import { submitCart } from '../../../store/action/cartAction';

const Submit = (props) => {
   const navigate = useNavigate();
   const { carts, submitCart } = props;
   const { cartItems } = carts;

   const totalPrice = () => {
      return cartItems ? cartItems.reduce((n, { price, quantity }) => n + price * quantity, 0) : 0;
   }

   const totalQuanlity = () => {
      return cartItems ? cartItems.reduce((n, { quantity }) => n + quantity, 0) : 0;
   }

   const handleSubmit = () => {
      if (validation()) {
         submitCart(carts, handleSuccess);
      }
   }

   const handleSuccess = (data) => {
      navigate(URL.SHOPPING_CART_PAYMENT.replace(':id', data));
   }

   const validation = () => {
      if (carts.shipping_full_name == undefined) {
         showErrorToasts("Vui lòng nhập Họ và tên!");
         return false;
      }

      if (carts.shipping_phone == undefined) {
         showErrorToasts("Vui lòng nhập Số điện thoại!");
         return false;
      }

      if (carts.shipping_address == undefined) {
         showErrorToasts("Vui lòng nhập Địa chỉ");
         return false;
      }

      if (carts.shipping_province == undefined) {
         showErrorToasts("Vui lòng chọn tỉnh/thành");
         return false;
      }

      if (carts.shipping_district == undefined) {
         showErrorToasts("Vui lòng chọn quận/huyện");
         return false;
      }

      if (carts.shipping_ward == undefined) {
         showErrorToasts("Vui lòng chọn phường/xã");
         return false;
      }
      return true;
   }
   return (
      <div className=" footer-section-container">
         <div className="footer-cart confirm">
            <div className="total-price-container">
               <span className="title-price">Tổng cộng ({formatPrice(totalQuanlity())})</span>
               <span className="price">{formatPrice(totalPrice())} ₫ </span>
            </div>
            <button type="button" className="app-btn app-btn-primary button-submit" onClick={handleSubmit}>
               Đặt hàng
            </button>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
   submitCart
})(Submit);
